import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import DialogServices from '../../services/dialog.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import RoutingService from '../../services/routing.service';
import { ModalBookingInstantStatusComponent } from '../../components/modal-booking-instant-status/modal-booking-instant-status.component';

@Component({
	standalone: true,
	selector: 'booking-instant-status',
	templateUrl: './booking-instant-status.component.html',
	imports: [ CommonModule, FormsModule ]
})
export default class BookingInstantStatusView implements OnInit {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private dialogServices: DialogServices = inject(DialogServices);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.bookingId = this.angularRoutingHelperService.getCurrentRouteParam('bookingId');
		this.vm.status = this.angularRoutingHelperService.getCurrentRouteParam('status');
		var allowedStatuses: Array<any> = ['pending', 'timeout', 'accepted', 'repeat_pending'];
		
		if (!this.vm.status || !this.vm.bookingId || allowedStatuses.indexOf(this.vm.status) === -1) {
			if (this.vm.dialog && this.vm.dialog.close) this.vm.dialog.close();
			this.angularRoutingHelperService.setPath('/', false, true);
			return;
		}
		
		this.serviceRestServices.getInstantBookingStatus({ bookingId: this.vm.bookingId }, (res) => {
			var currentStatus: any = res.status.toLowerCase();
			
			if (res.refund || !currentStatus || allowedStatuses.indexOf(currentStatus) === -1) {
				this.angularRoutingHelperService.setPath('/', false, true);
				return;
			}
			
			var isModalOpen: any = this.angularHelperService.element(document.body).hasClass('md-dialog-is-showing')
				|| this.angularHelperService.element(document.body).hasClass('md-dialog-is-showing-1');
			if (currentStatus !== this.vm.status) {
				this.angularRoutingHelperService.setPath('/booking/instant/' + this.vm.bookingId + '/' + currentStatus, !isModalOpen, true);
				this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Instant_Bookings.STATUS_CHANGED, currentStatus);
			} else {
				if (!isModalOpen) this.openDialog();
			}
			
		}, () => {
			if (this.vm.dialog && this.vm.dialog.close) this.vm.dialog.close();
			this.angularRoutingHelperService.setPath('/', false, true);
		});
	}
	
	openDialog() {
		this.vm.dialog = this.dialogServices.show({
			controller: ModalBookingInstantStatusComponent,
			status: this.vm.status,
			bookingId: this.vm.bookingId
		});
	}
	
}